import React from "react";
import { Form, Col } from "react-bootstrap";
import { DateRangePicker } from "rsuite";
import moment from "moment/min/moment-with-locales";
import { convertMomentToDatepickerFormat } from "../HelperFunctions";

export default function DatesPicker({
    formData,
    setFormData,
    predefinedRanges,
    latestAvailableDate,
    hoverRange,
    disabled,
    showWeekNumbers = false,
    oneTap = false,
}) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-2 min-w-date-range-picker">
            <Form.Label>Time period</Form.Label>
            <DateRangePicker
                value={formData.dateRange}
                onChange={value => setFormData({ ...formData, dateRange: value })}
                placeholder="Select time period"
                format={convertMomentToDatepickerFormat(moment.localeData(moment.locale()).longDateFormat("l"))}
                ranges={predefinedRanges}
                shouldDisableDate={date => moment(moment(date).startOf("day").format()).isAfter(moment(latestAvailableDate).local())}
                block
                hoverRange={hoverRange}
                isoWeek
                showOneCalendar
                showWeekNumbers={showWeekNumbers}
                oneTap={oneTap}
                disabled={disabled}
            />
        </Form.Group>
    );
}

export const latestDay = (date, datesOnly = false) => {
    const range = [moment(date).subtract(1, "day").toDate(), moment(date).toDate()];
    if (datesOnly) return range;
    return { label: "Latest day", value: range, placement: "left" };
};
export const latestWeek = (date, datesOnly = false) => {
    const range = [moment(date).subtract(7, "day").toDate(), moment(date).toDate()];
    if (datesOnly) return range;
    return { label: "Latest 7 days", value: range, placement: "left" };
};
export const latest2Weeks = (date, datesOnly = false) => {
    const range = [moment(date).subtract(14, "day").toDate(), moment(date).toDate()];
    if (datesOnly) return range;
    return { label: "Latest 14 days", value: range, placement: "left" };
};
export const latestMonth = (date, datesOnly = false) => {
    const range = [moment(date).subtract(30, "day").toDate(), moment(date).toDate()];
    if (datesOnly) return range;
    return { label: "Latest 30 days", value: range, placement: "left" };
};
export const latestQuarter = (date, datesOnly = false) => {
    const range = [moment(date).subtract(90, "day").toDate(), moment(date).toDate()];
    if (datesOnly) return range;
    return { label: "Latest 90 days", value: range, placement: "left" };
};
export const latestYear = (date, datesOnly = false) => {
    const range = [moment(date).subtract(365, "day").toDate(), moment(date).toDate()];
    if (datesOnly) return range;
    return { label: "Latest 365 days", value: range, placement: "left" };
};

export const latestFullWeek = (date, datesOnly = false) => {
    const range = [
        moment(date).subtract(1, "week").add(1, "minute").startOf("isoWeek").toDate(),
        moment(date).subtract(1, "week").add(1, "minute").endOf("isoWeek").toDate(),
    ];
    if (datesOnly) return range;
    return { label: "Latest week", value: range, placement: "left" };
};
export const latestFull2Weeks = (date, datesOnly = false) => {
    const range = [
        moment(date).subtract(1, "week").add(1, "minute").subtract(1, "week").startOf("isoWeek").toDate(),
        moment(date).subtract(1, "week").add(1, "minute").endOf("isoWeek").toDate(),
    ];
    if (datesOnly) return range;
    return { label: "Latest 2 weeks", value: range, placement: "left" };
};
export const latestFull4Weeks = (date, datesOnly = false) => {
    const range = [
        moment(date).subtract(1, "week").add(1, "minute").subtract(3, "week").startOf("isoWeek").toDate(),
        moment(date).subtract(1, "week").add(1, "minute").endOf("isoWeek").toDate(),
    ];
    if (datesOnly) return range;
    return { label: "Latest 4 weeks", value: range, placement: "left" };
};
export const latestFullMonth = (date, datesOnly = false) => {
    const range = [
        moment(date).subtract(1, "week").add(1, "minute").subtract(1, "month").startOf("isoWeek").toDate(),
        moment(date).subtract(1, "week").add(1, "minute").endOf("isoWeek").toDate(),
    ];
    if (datesOnly) return range;
    return { label: "Latest month", value: range, placement: "left" };
};
export const latestFullQuarter = (date, datesOnly = false) => {
    const range = [
        moment(date).subtract(1, "week").add(1, "minute").subtract(1, "quarter").startOf("isoWeek").toDate(),
        moment(date).subtract(1, "week").add(1, "minute").endOf("isoWeek").toDate(),
    ];
    if (datesOnly) return range;
    return { label: "Latest quarter", value: range, placement: "left" };
};
export const latestFullYear = (date, datesOnly = false) => {
    const range = [
        moment(date).subtract(1, "week").add(1, "minute").subtract(1, "year").startOf("isoWeek").toDate(),
        moment(date).subtract(1, "week").add(1, "minute").endOf("isoWeek").toDate(),
    ];
    if (datesOnly) return range;
    return { label: "Latest year", value: range, placement: "left" };
};
